export default "__VITE_ASSET__u_Rkq1Om__"